import _get from 'lodash/get'

export default item => _get(item, 'sys.contentType.sys.id', null)



// WEBPACK FOOTER //
// ./src/utils/getContentType.js